import { bindable } from 'aurelia-framework';
import { IImportAM } from './import-api';

export class ImportAuditInfo {
	@bindable importEntry: IImportAM;
}
